import { createContext, useContext } from 'react';

import { BrandAffinityXAIContextState } from '../types/xaiContext';

export const defaultState = { isLoading: false, isError: false };

export const BrandAffinityXAIContext = createContext<BrandAffinityXAIContextState>(defaultState);

export const useBrandAffinityXAIContext = () => useContext(BrandAffinityXAIContext);
